import { useQuery } from "@apollo/client";
import { graphql } from "@/shared/gql";
import { UNBATCHED_CONTEXT, getPreloadQuery } from "@/shared/gql/apollo-client";
import { SourcingWebsiteUrlStatus } from "@/shared/gql/graphql";

const FetchSourcingWebsiteCounts = graphql(`
  query FetchSourcingWebsiteCounts(
    $all: SearchSourcingWebsitesInput!
    $withTenderPage: SearchSourcingWebsitesInput!
    $neverScanned: SearchSourcingWebsitesInput!
  ) {
    superAdmin {
      all: sourcingWebsites(input: $all) {
        paginatorInfo {
          total
        }
      }
      withTenderPage: sourcingWebsites(input: $withTenderPage) {
        paginatorInfo {
          total
        }
      }
      neverScanned: sourcingWebsites(input: $neverScanned) {
        paginatorInfo {
          total
        }
      }
      sourcingReviewQueueSummary {
        issue
        bucket
        count
      }
    }
  }
`);

const FIRST_ROW = { page: 1, take: 1 };

const COUNTS_OPTIONS = {
  variables: {
    all: { paginator: FIRST_ROW },
    withTenderPage: { tenderPageFound: true, paginator: FIRST_ROW },
    neverScanned: {
      urlStatus: SourcingWebsiteUrlStatus.Pending,
      paginator: FIRST_ROW,
    },
  },
  context: UNBATCHED_CONTEXT,
};

export const preloadSourcingWebsiteCounts = () => {
  getPreloadQuery()(FetchSourcingWebsiteCounts, COUNTS_OPTIONS);
};

export const useFetchSourcingWebsiteCounts = () => {
  const { data, loading } = useQuery(
    FetchSourcingWebsiteCounts,
    COUNTS_OPTIONS,
  );
  const counts = data?.superAdmin;

  return {
    isLoading: loading && !counts,
    all: counts?.all.paginatorInfo.total,
    withTenderPage: counts?.withTenderPage.paginatorInfo.total,
    needAttention: counts?.sourcingReviewQueueSummary.reduce(
      (total, row) => total + row.count,
      0,
    ),
    neverScanned: counts?.neverScanned.paginatorInfo.total,
  };
};
